<template>
    <div>
        <div class="month-option">
            <button @click.prevent="onGoPrevMonth()" :disabled="!isFutureDate() || isGettingData" class="nav-arrow"><img
                    :src="('//' + currentURL + '/app/themes/leightons/images/navigation-arrow' + ((!isFutureDate()) ? '-black' : '') + '.svg')" /></button>
            <div class="month">
                <!-- <img :src="'//' + currentURL + '/app/themes/booking/images/date-icon.svg'" /> -->
                <img :src="'//' + currentURL + '/app/themes/leightons/images/date-icon-purple.svg'" />
                <p>{{ displayMonthYear() }}</p>
            </div>
            <button @click.prevent="onGoNextMonth()" :disabled="!isIn6Months() || isGettingData"><img
                    :src="'//' + currentURL + '/app/themes/leightons/images/navigation-arrow-right.svg'" /></button>
        </div>

        <ul>
            <template v-if="!isGettingData">
                <li @click="(evt) => { if (this.activeItem !== slot.date) toggleItem(slot.date, evt) }"
                    v-for="(slot, index) in filterTimeSlots" :key="slot.date"
                    :class="{ active: activeItem === slot.date, hide: index > (currentIndex - 1), inactive: activeItem !== slot.date }">
                    <div class="date">
                        <img :src="'//' + currentURL + '/app/themes/leightons/images/calendar-icon-purple.svg'" class="cal" />
                        <div>
                            <h3>{{ slot.date }}</h3>
                            <p>{{ slot.available.join(', ') }} available</p>
                        </div>
                        <div class="arrow-container">
                            <span @click.prevent="(evt) => { toggleItem(slot.date, evt) }" class="collapsed"
                                :class="{ active: activeItem === slot.date }"><img
                                    :src="'//' + currentURL + '/app/themes/leightons/images/dropdown-arrow-purple.svg'"
                                    class="arrow" /></span>
                        </div>
                    </div>
                    <div class="mobile">
                        <p>{{ slot.available.join(', ') }} available</p>
                    </div>
                    <div id="time" v-show="activeItem === slot.date">
                        <template v-for="option in slot.options" :key="option.id">
                            <button @click.prevent="selectDate(option)" class="btn-toggle"
                                :class="{ active: checkOptionIsTheSelectedDate(option) }">{{ option.time24 }}</button>
                        </template>
                    </div>
                </li>
            </template>
            <li v-if="filterTimeSlots.length == 0 && !isGettingData">
                <p>No data available.</p>
            </li>
            <li v-if="isGettingData">
                <p>Checking appointment times...</p>
            </li>
        </ul>
        <div class="show-more" v-if="(!isGettingData && filterTimeSlots.length > 0)">
            <p v-if="currentIndex <= filterTimeSlots.length">Showing {{ currentIndex }} of {{ filterTimeSlots.length }}</p>
            <p v-if="currentIndex > filterTimeSlots.length">Showing {{ filterTimeSlots.length }} of {{ filterTimeSlots.length }}
            </p>
            <button class="button secondary-button" @click.prevent="onShowMoreDates"
                v-if="(currentIndex < filterTimeSlots.length)">{{ getShowMoreText }}</button>
        </div>
        <template v-if="getTimeslotsData"></template>
    </div>
</template>

<script>
export default {

    created() {
        this.currentURL = location.host;
    },

    name: "BookingDateMonth",
    emits: ["onSelectedDateSlotChanged"],
    props: ["appointment"],
    data() {
        return {
            currentURL: "",
            timeslots: [],
            activeDate: new Date(),
            activeItem: "",
            isGettingData: false,
            directonForward: true,
            MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            pageSize: 5,
            currentIndex: 5,
        };
    },

    methods: {
        checkOptionIsTheSelectedDate(option) {
            if (this.appointment.date.start !== "") {
                if (this.appointment.date.start === option.start) {
                    // this.selectDate(option); // Circular function call
                    return true;
                }
            }
            return false;
        },
        onShowMoreDates() {
            this.currentIndex += this.pageSize;
        },
        isFutureDate() {
            const today = new Date();
            if (this.activeDate.getFullYear() > today.getFullYear()) return true;
            else if (this.activeDate.getFullYear() == today.getFullYear()) {
                return this.activeDate.getMonth() > today.getMonth();
            }
        },
        isIn6Months() {
            const d1 = new Date();
            const d2 = this.activeDate;
            let months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            months = (months <= 0) ? 0 : months;
            return months - 6 < 0; //not over 6 months from now
        },
        onGoNextMonth() {
            console.log('onGoNextMonth');
            this.directonForward = true;
            this.activeDate.setDate(1);// set to first day of the month so the next line works correctly in case of overloading the max day of next month (31 Jan vs 31 Feb)
            this.activeDate.setMonth(this.activeDate.getMonth() + 1);
            this.getTimeslotsDataByMonth();
        },
        onGoPrevMonth() {
            console.log('onGoPrevMonth');
            this.directonForward = false;
            this.activeDate.setDate(1);// set to first day of the month so the next line works correctly in case of overloading the max day of next month (31 Jan vs 31 Feb)
            this.activeDate.setMonth(this.activeDate.getMonth() - 1);
            this.getTimeslotsDataByMonth();
        },
        toggleItem(itemdate, evt) {
            if (this.activeItem === itemdate) {
                this.activeItem = false;
                // Close arrow clicked; prevent bubbling to parent div or it will instantly re-open
                evt.stopPropagation();
            } else {
                this.activeItem = itemdate;
            }
        },
        selectItem(itemdate) {
            this.activeItem = itemdate;
        },
        selectDate(option) {
            this.$emit("onSelectedDateSlotChanged", option);
        },
        getTimeSlotsOfLocation(service, location, month, year, localeDt) {
            const today = new Date();
            if (!(today.getFullYear() === year && (today.getMonth() + 1) === month)) {
                //if not the same day as today, get all the slots
                localeDt = "";
            }

            //always get the new data from Swagger
            this.getTimeSlotsOfLocationByMonth(service, location, month, year, localeDt);
            /*
            const api = window.wpAjax.ajaxUrl;
            this.axios.get(api + "?action=get_timeslots_of_location&location=" + location + "&service=" + encodeURIComponent(service) + "&month=" + month + "&year=" + year + "&localedt=" + encodeURIComponent(localeDt))
                .then((response) => {
                if (response.data.success == true) {
                    const data_response = response.data.data??[];
                    if (data_response.length > 0) {
                        this.timeslots = data_response;
                        this.isGettingData = false;
                    } else {
                        this.getTimeSlotsOfLocationByMonth(service, location, month, year, localeDt);
                    }
                }
                })
                .catch(() => {
                    this.isGettingData = false;
                });
                */
        },
        getTimeSlotsOfLocationByMonth(service, location, month, year, localeDt) {
            this.isGettingData = true;

            // const api = window.wpAjax.ajaxUrl;
            this.axios.get("/wp-json/leightons/v1/get-timeslots?location=" + location + "&service=" + escape(service) + "&month=" + month + "&year=" + year + "&localedt=" + encodeURIComponent(localeDt))
                .then((response) => {
                    // If we have data, format the timeslots
                    if (response.data.data.length > 0) {
                        this.formatTimeslotData(response.data.data);
                    } else if (this.directonForward && this.isIn6Months()) {
                        //BRAYTHCPW-321 get data of the next month if the current month has no data available
                        // EDIT Luke 1minus1 - only go on to next month, if going fowards too (otherwise, we'll get stuck in a loop)
                        this.onGoNextMonth();
                    }
                })
                // .catch(() => {
                //     this.isGettingData = false;
                // })
                .finally(() => {
                    this.isGettingData = false;
                });
        },
        formatTimeslotData(timeslots) {
            // Array by day
            // with available timeslots ie ['14:00', 14:30', '15:00']
            // date 'Wednesday 14th Jan'
            // date1 'Y-m-d'
            // options [ { calendar_Date, date, id, time, time24 } ]

            // Loop through timeslots group by day
            // Then loop through all the timeslots for that day and pick out the timeslots that are available

            const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const days = [];

            // let previousDay = null;
            timeslots.forEach(slot => {
                const [date, time] = slot.start.split('T');
                let [year, month, day] = date.split('-');
                day = parseInt(day);
                const [hours, minutes] = time.split(':');

                const dayIndex = new Date(slot.start).getDay();
                const monthIndex = new Date(slot.start).getMonth();
                const dateLabel = `${dayNames[dayIndex]} ${day} ${this.MONTHS[monthIndex]}`;

                // Get the hours and minues in 12hour format
                let hours12 = hours > 12 ? hours - 12 : parseInt(hours);
                // Pad the hours with a leading zero if needed
                hours12 = hours12 < 10 ? '0' + hours12 : hours12;

                // Check if we have a new day in days array
                if (!days[day]) {
                    days[day] = {
                        available: [],
                        date: dateLabel,
                        options: []
                    };
                }

                // Add the timeslot to the day
                days[day].options.push({
                    ...slot,
                    date: dateLabel,
                    time: `${hours12}:${minutes} ${hours >= 12 ? 'pm' : 'am'}`,
                    time24: `${hours}:${minutes}`,
                    calendar_date: `${date} ${hours}:${minutes}:00`
                });
                days[day].available.push(`${hours}:${minutes}`);
            })

            this.timeslots = days.filter(val => val); // Reindexes the array to 0..n
        },
        initActiveItem() {
            if (this.appointment.date.date != '') {
                this.activeItem = this.appointment.date.date;
            } else {
                this.activeItem = "";
                if (this.timeslots && this.timeslots.length > 0) {
                    this.activeItem = this.timeslots[0]['date'];
                }
            }
        },

        displayMonthYear() {
            return this.MONTHS[this.activeDate.getMonth()] + ' ' + this.activeDate.getFullYear();
        },
        getCurrentMonth() {
            return this.activeDate.getMonth() + 1;
        },
        getCurrentYear() {
            return this.activeDate.getFullYear();
        },
        getLocaleDateTimeNow() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1;
            const day = now.getDate();
            const hour = now.getHours();
            const minute = now.getMinutes();

            return `${year}-${month}-${day} ${hour}:${minute}:0`;
        },
        getTimeslotsDataByMonth() {
            this.currentIndex = this.pageSize;
            if (this.appointment.service.id !== '' && this.appointment.practice.ID !== 0) {
                this.getTimeSlotsOfLocation(this.appointment.service.id, this.appointment.practice.post_name, this.getCurrentMonth(), this.getCurrentYear(), this.getLocaleDateTimeNow());
            }
        }

    },

    computed: {

        getShowMoreText() {
            const nb = this.currentIndex;
            const item_to_load = Math.min(this.pageSize, this.filterTimeSlots.length - nb);
            return `Show ${item_to_load} more`;
        },
        getTimeslotsData() {
            if (this.appointment.service.id !== '' && this.appointment.practice.ID !== 0) {
                this.getTimeslotsDataByMonth();
            }
            return true;
        },

        filterTimeSlots() {
            if (this.timeslots && this.timeslots.length > 0) {
                this.initActiveItem();
                return this.timeslots;
            }
            return [];
        }
    }
}
</script>

<style lang="postcss" scoped>
div {
    @apply text-left;
}

#time {
    @apply flex flex-row flex-wrap -mx-[10px] md:-mx-[15px];
}

button.btn-toggle {
    @apply bg-white border-grey border hover:border-purple-darker text-charcoal p-[15px] font-avenir-medium rounded-full mt-[10px] sm:mt-[20px] mx-[10px] md:mx-[15px] w-[calc(50%_-_20px)] md:w-[calc(25%_-_30px)];

    &.active {
        @apply text-grey-darker bg-purple-lighter border-purple-darker;
    }
}

.month-option {
    @apply flex border-b border-navy border-opacity-20 pb-[20px] mb-[40px];

    .month {
        @apply w-full flex justify-center;

        img {
            @apply max-w-[50px] mr-[15px];
        }
    }

    img {
        @apply max-w-[26px];
    }

    p {
        @apply text-base sm:text-[18px] text-grey-darker pt-[12px] uppercase tracking-wider font-avenir-medium;
    }
}

li.active {
    @apply border-2 border-purple-darker;
}

li.hide {
    @apply hidden;
}

li.inactive {
    @apply cursor-pointer;
}

li {
    @apply p-[20px] sm:p-10 sm:pt-8 bg-white mb-5 last:mb-10 md:mb-[40px] drop-shadow-lg rounded-[10px];

    .mobile {
        @apply block sm:hidden;

        p {
            @apply pb-[10px];
        }
    }

    .date {
        @apply grid grid-cols-12 mb-[10px] md:mb-0;

        div {
            @apply col-span-9 text-left pl-[5px] sm:pl-0;

            h3 {
                @apply uppercase text-grey-darker text-[18px] sm:text-[22px] mb-[5px] pt-[4px] sm:pt-0;
            }

            p {
                @apply hidden sm:block;
            }
        }

        .cal {
            @apply col-span-2 sm:col-span-1 max-w-[35px] h-[35px];
        }

        .arrow-container {
            @apply pt-[3px] sm:pt-0 col-span-1 sm:col-span-2 flex justify-end cursor-pointer;

            .active {
                > img {
                    @apply rotate-180;
                }
            }

            .arrow {
                @apply max-w-[26px] h-[26px];
            }
        }
    }
}

.show-more {
    @apply mx-auto text-center pb-[40px];

    p {
        @apply mb-[10px] font-avenir-medium;
    }

    button.btn {
        @apply w-full sm:w-auto;
    }
}
</style>